export const VERIFYEMAIL = 'VERIFYEMAIL'